import React from 'react'
import './Blogs.css'

function Blogs() {
  return (
    <>
    <h1 className='H2'>Our Blogs</h1>
    <div class="Blogs">
   <div class="Blocks">
    <div className='imageblog'>
      <a href="https://blog.ethereum.org/2023/08/07/nb-fellows-cohort-3">
            <img src="https://blog.ethereum.org/_ipx/w_3840,q_75/https%3A%2F%2Fstorage.googleapis.com%2Fethereum-hackmd%2Fupload_bc451adb280fe2de40c39e1246ddd6db.png?url=https%3A%2F%2Fstorage.googleapis.com%2Fethereum-hackmd%2Fupload_bc451adb280fe2de40c39e1246ddd6db.png&w=3840&q=75" alt="" />
      </a>
      </div>
      <h3>The Human Stories of Ethereum</h3>
   </div>
   <div className='Blocks'>
   <div className='imageblog'>
    <a href='https://www.risein.com/blog/how-do-you-attract-developers-to-your-chain-and-ecosystem-2'>
      <img src='https://uploads-ssl.webflow.com/649ed911a30a27fa26890a5a/64b91281c83686e55e88a55e_pexels-cottonbro-studio-7437489.jpg' alt=''/>
      </a>
      </div>
    <h3>How do you attract developers to your chain and ecosystem?</h3>

   </div>
   <div className='Blocks'>
   <div className='imageblog'>
    <a href='https://blogs.oracle.com/blockchain/post/blockchain-adoption-supply-chain-and-sustainability-applications'>
        <img src='https://blogs.oracle.com/content/published/api/v1.1/assets/CONTDD2055A17D5B497ABD054FB1A8B9AF41/Medium?format=jpg&type=responsiveimage&channelToken=23dcd1b04a6f4bedbfe37fb8181fd098&cb=_cache_847a' alt=''/>
        </a>
        </div>
    <h3>Blockchain Adoption</h3>
   </div>
    </div>
    <div className='nextBlog'>
    <div class="Blocks">
    <div className='imageblog'>
      <a href="https://blog.ethereum.org/2023/06/29/road-to-devcon7-grants">
            <img src="https://blog.ethereum.org/_ipx/w_3840,q_75/https%3A%2F%2Fstorage.googleapis.com%2Fethereum-hackmd%2Fupload_26ffe228bf48549e6c75df1a0cb26836.png?url=https%3A%2F%2Fstorage.googleapis.com%2Fethereum-hackmd%2Fupload_26ffe228bf48549e6c75df1a0cb26836.png&w=3840&q=75" alt="" />
      </a>
      </div>
      <h3>Announcing The Road To Devcon Grants</h3>
   </div>
   <div className='Blocks'>
   <div className='imageblog'>
    <a href='https://blog.ethereum.org/2023/08/02/kzg-special-contributions'>
      <img src='https://blog.ethereum.org/_ipx/w_3840,q_75/https%3A%2F%2Fstorage.googleapis.com%2Fethereum-hackmd%2Fupload_b8f57609d139ce61f1c708e50f6d4809.png?url=https%3A%2F%2Fstorage.googleapis.com%2Fethereum-hackmd%2Fupload_b8f57609d139ce61f1c708e50f6d4809.png&w=3840&q=75' alt=''/>
      </a>
      </div>
    <h3>KZG Ceremony Special Contributions</h3>

   </div>
   <div className='Blocks'>
   <div className='imageblog'>
    <a href='https://blog.ethereum.org/2023/05/03/secured-5-disclosures-update'>
        <img src='https://blog.ethereum.org/_ipx/w_3840,q_75/%2Fimages%2Fposts%2Fupload_630d77544672a1e0df792c0d71489bd6.jpg?url=%2Fimages%2Fposts%2Fupload_630d77544672a1e0df792c0d71489bd6.jpg&w=3840&q=75' alt=''/>
        </a>
        </div>
    <h3>Public Vulnerability Disclosures Update</h3>
   </div>

    </div>
    </>
  )
}

export default Blogs
